<template>
    <div class="animated fadeIn">
      <b-row>
          <b-col sm="12">
            <b-card header-tag="header" footer-tag="footer">
              <div slot="header">
                <strong>Performance Report</strong>
              </div>
                
        <!-- code for tab -->
              <b-row>
                <b-col >
                    
                <div>
                  <ul class="nav nav-tabs nav-justified">
                    <li class="nav-item">
                      <a @click="activeTab = 1;" class="nav-link" :class="{'active' : isActiveTab(1)}" >Rider-Wise</a>
                    </li>

                    <li class="nav-item">
                      <a @click="activeTab = 2;" class="nav-link " :class="{'active' : isActiveTab(2)}">Hub-Wise</a>
                    </li>

                    <!-- <li class="nav-item">
                      <a @click="activeTab = 3;" class="nav-link " :class="{'active' : isActiveTab(3)}">Super-Wise</a>
                    </li>             -->
                  </ul>
                </div>
                        
                </b-col>
              </b-row>
              <component :is="currentComponent" class="mt-5"></component>
            </b-card>
          </b-col>
      </b-row>
    </div>
</template>

<script>
import superWisePerformanceReport from "./superWisePerformanceReport.vue";
import hubWisePerformanceReport from "./hubWisePerformanceReport.vue";
import riderWisePerformanceReport from "./riderWisePerformanceReport.vue";

  export default{
    components: {
      superWisePerformanceReport,
      hubWisePerformanceReport, 
      riderWisePerformanceReport 
    },
    data: function(){
      return{
        activeTab: 1,
        //selected_status:'Rider_Wise',
      }
    },
    computed: {
        currentComponent(){
          console.log("this.activeTab----> ",this.activeTab);
            if(this.activeTab === 1)           
              return "riderWisePerformanceReport";
            else if(this.activeTab === 2)           
              return "hubWisePerformanceReport";
            else
              return "superWisePerformanceReport";
        }
    },

    created: function(){
        this.isActiveTab(1);
    },

    methods: {
        isActiveTab(id)
        {
          return this.activeTab === id;
        },
    }
  }
</script>

<style>

</style>